import styled from '@emotion/styled'

export const StyledUl = styled.ul`
  list-style-type: '・';
  margin: 24px 0 0 14px;
  color: #2e72d8;
`
